import { useParams, useNavigate } from "react-router-dom"

import { useFirestoreContext } from "../context/FirestoreContext"

import Card from "../components/Card"
import NotFound from "./NotFound"
export default function Single() {
  const { id } = useParams()//Get id from URL parameters
  const navigate = useNavigate()
  const { state } = useFirestoreContext()
  const item = state.items.find(item => item.id === id)
  if (!item) {return <NotFound />}
  return (
    <>
      <button className="btn btn-link" onClick={() => navigate(-1)}>⬅️ BACK</button>
      <div className="d-flex justify-content-center mb-5">
        <Card {...item} />
      </div>
    </>
  )
}